import Api from './Api';
import Configuracao from '../util/Configuracao';

class AssistenciaOdontoApi extends Api {
  async consultarAnosPericia () {
    try {
      const urlConsultarAnosPericia = Configuracao.getConfiguracao().urlConsultarAnosPericia;
      const response = await this.fetch(urlConsultarAnosPericia);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }  
  async consultarNumPericias () {
    try {
      const urlConsultarNumPericias = Configuracao.getConfiguracao().urlConsultarNumPericias;
      const response = await this.fetch(urlConsultarNumPericias);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarReembolsos (ano, mes, numMatricula, codEstado, dataInicial, dataFinal, incluirNaoPagos) {
    try {
      const urlConsultarReembolsosOdonto = Configuracao.getConfiguracao().urlConsultarReembolsosOdonto +
      ano + '/' +
      mes + '/' +
      numMatricula + '/' +
      codEstado + '/' +
      dataInicial + '/' +
      dataFinal + '/' +
      incluirNaoPagos;
      const response = await this.fetch(urlConsultarReembolsosOdonto, 'post');
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async incluirReembolso (reembolso) {
    try {
      const urlIncluirReembolsoOdonto = Configuracao.getConfiguracao().urlIncluirReembolsoOdonto;
      const response = await this.fetch(urlIncluirReembolsoOdonto, 'put', reembolso);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarReembolso (reembolso) {
    try {
      const urlAlterarReembolsoOdonto = Configuracao.getConfiguracao().urlAlterarReembolsoOdonto;
      const response = await this.fetch(urlAlterarReembolsoOdonto, 'put', reembolso);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirReembolso (numPericia, anoPericia) {
    try {
      const urlExcluirReembolsoOdonto = Configuracao.getConfiguracao().urlExcluirReembolsoOdonto + numPericia + '/' + anoPericia;
      const response = await this.fetch(urlExcluirReembolsoOdonto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarDentistas (CPF_CNPJ, nome) {
    try {
      const urlDentistas = Configuracao.getConfiguracao().urlDentistas + CPF_CNPJ + '/nome/' + nome;
      const response = await this.fetch(urlDentistas);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }  
  async consultarNomeDentista (CPF_CNPJ) {
    try {
      const urlConsultarNomeDentista = Configuracao.getConfiguracao().urlConsultarNomeDentista + CPF_CNPJ;
      const response = await this.fetch(urlConsultarNomeDentista);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarNomeDentistaReceita (CPF_CNPJ) {
    try {
      const urlConsultarNomeDentistaReceita = Configuracao.getConfiguracao().urlConsultarNomeDentistaReceita + CPF_CNPJ;
      const response = await this.fetch(urlConsultarNomeDentistaReceita);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async incluirDentista (dentista) {
    try {
      const urlIncluirDentista = Configuracao.getConfiguracao().urlIncluirDentista;
      const response = await this.fetch(urlIncluirDentista, 'put', dentista);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarDentista (dentista) {
    try {
      const urlAlterarDentista = Configuracao.getConfiguracao().urlAlterarDentista;
      const response = await this.fetch(urlAlterarDentista, 'put', dentista);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirDentista (codDentista) {
    try {
      const urlExcluirDentista = Configuracao.getConfiguracao().urlExcluirDentista + codDentista;
      const response = await this.fetch(urlExcluirDentista, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
}
export default AssistenciaOdontoApi;
